/**
 * Public site origin for canonical URLs, Open Graph, and JSON-LD.
 * Set REACT_APP_SITE_URL in production (e.g. https://www.yourdomain.com).
 */
export function getSiteOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_SITE_URL || "";
}

export function absoluteUrl(pathname) {
  const origin = getSiteOrigin();
  if (!pathname) return origin || "/";
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return origin ? `${origin}${path}` : path;
}
